import request from '@/utils/request';
import configR from '@/configs.js';
const getters = {
  // 设备
  // device: state => state.app.device,
  // token
  schoolCode: state => configR.envConfigs.SCHOOL_CODE,
  token: state => state.user.token,
  themeConfig: state => state.user.themeConfig,
  touristThemeConfig: state => state.user.touristThemeConfig,
  // 头像
  avatar: state => `${configR.envConfigs.PERSON_CENTER_API}api/v1/me/portrait?token=${state.user.token}`,
  // 用户信息
  userInfo: state => state.user.userInfo,
  // 用户按钮列表
  userButtons: state => state.user.userButtons,
  // 用户导航
  // userNav: state => {
  //   return state.user.userNav.filter(item => {
  //     return (
  //       !item.BUTTON_CODE ||
  //       state.user.userButtons.indexOf(item.BUTTON_CODE) > -1
  //     );
  //   });
  // },
  // 用户导航
  userNav: state => state.user.userNav,
  // 用户角色 6 超级管理员
  userRoles: state => state.user.userRoles,
  // 是否是超级管理员
  superAmin: state => state.user.superAmin,
  // 用户导航总白名单
  userWhiteNavs: state => state.user.userWhiteNavs,
  // 用户导航授权验证的白名单
  userAuthedWhiteNavs: state => state.user.userAuthedWhiteNavs,
  // 模块列表
  userModules: state => state.user.userModules,
  // 用户桌面列表
  userDesktop: state => state.user.userDesktop,
  // 桌面配置窗口状态
  desktopSetting: state => state.app.desktopSetting,
  // 用户身份
  userIdentity: state => state.user.userIdentity,
  // 全局搜索结果
  userGolbalSearch: state => state.user.userGolbalSearch,
  // 门户请求域名
  serveUrl: state => configR.envConfigs.PORTAL_API,
  // 事务域名
  flowServeUrl: state => configR.envConfigs.TTC_API,
  // 消息请求域名
  messageUrl: state => configR.envConfigs.MESSAGE_API_URL+'center/',
  // 个人中心域名
  adminCenterUrl: state => configR.envConfigs.ADMIN_CENTER_API,
  config:state => configR.envConfigs,
  request: state => request,
  systemSetting: state => state.user.systemSetting,
  // 未读消息数量
  unReadedMessageCount:state=> state.home.unReadedMessageCount,
  organizationName: state => state.user.organizationName,
  // 是否刷新页面
  refresh: state => state.user.refresh,
  // 记录系统状态
  systemStatus: state => state.user.systemStatus,
  // 系统状态值集合
  systemStatusSetting: state => state.user.systemStatusSetting,

};
export default getters;
